export default Object.freeze({
  EVENT_CATEGORY: 'buttonTap',
  EVENT_ACTION: 'AJIOWallet',
  LABELS: {
    PAYMENT_MODE: 'payment mode',
    REDEMPTION_OPTION_VIEW_DETAILS: 'Redemption option view details',
    WHAT_IS_AJIO_WALLET: 'What is SuperCash',
    GO_TO_WALLET_SCREEN: 'Go to wallet screen',
    GO_TO_CASH: 'Go to wallet screen',
    GO_TO_POINTS: 'Go to SuperCash',
    GO_TO_PENDING_POINTS: 'Go to Pending SuperCash',
    GO_TO_ACTIVE_POINTS: 'Go to Active SuperCash',
    GO_TO_SPEND_HISTORY: 'Go to spend history',
    PENDING_POINTS_INFO: 'Pending points info'
  }
});
